<template>
  <div>
    <label :class="{ 'sr-only': hide_label }" :for="'input-' + id">{{ text }}</label>
    <b-form-checkbox-group
      @change="emitToParent"
      v-model="value"
      :id="'input-' + id"
      :options="options"
      switches
      :stacked="stacked"
    />
  </div>
</template>

<script>
export default {
  name: 'InputSwitches',
  props: ['val', 'id', 'text', 'options', 'stacked', 'hide_label'],
  data () {
    return {
      value: this.val
    }
  },
  methods: {
    emitToParent: function () {
      this.$emit('passToParent', this.id, this.value)
    }
  }
}
</script>

<style scoped>
.custom-control-label:after {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/templates/InputSwitches/InputSwitches.vue